export default __webpack_public_path__ + "13b5f2c34e9a4cd0071802a466c7e75b.svg";